import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Animation1Gif from "@images/game-pass/animation_1.gif";
import Animation2Gif from "@images/game-pass/animation_2.gif";
import Animation3Gif from "@images/game-pass/animation_3.gif";
import Animation4Gif from "@images/game-pass/animation_4.gif";
import Animation5Gif from "@images/game-pass/animation_5.gif";
import Animation6Gif from "@images/game-pass/animation_6.gif";

const ImageSlider = () => {
  const sliderRef = useRef(null);

  const settings = {
    className: "center",
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 3,
    swipeToSlide: true,
    arrows: false,
    dots: false,
    autoplay: true,
    speed: 7000,
    cssEase: "linear",
    centerMode: true,
    autoplaySpeed: 0,
    // rtl: true,
  };

  // useEffect(() => {
  //   const slider = sliderRef.current;
  //
  //   // Start autoplay after 2 seconds
  //   const delay = 3000;
  //   const timer = setTimeout(() => {
  //     if (slider) {
  //       slider.slickPlay();
  //     }
  //   }, delay);
  //
  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, []);



  return (
    <div className="flex flex-col">
      <Slider {...settings} ref={sliderRef}>
        <div>
          <img src={Animation6Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation5Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation4Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation3Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation2Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
        <div>
          <img src={Animation1Gif} className='xl:w-[800px] w-[664px] max-h-[374px] px-[6px] rounded-[19.166px]' alt="animation-1" />
        </div>
      </Slider>
    </div>
  );
};

export default ImageSlider;